// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__FwClP","footer":"ChangeClinic_footer__1eSMZ"};